<template>
    <div>
        <div class="space-y-6">
            <!-- CLIENT -->
            <div>
                <label class="text-sm font-bold text-gray-900">Client</label>

                <div class="flex gap-2 mt-1">
                    <div class="relative flex-1">
                        <i class="fas fa-user absolute left-3 top-3 text-gray-400"></i>

                        <input type="text" v-model="clientSearch" placeholder="Rechercher un client..." class="pl-9 w-full rounded-lg border border-gray-300 focus:outline-none text-sm py-2" @focus="showSuggestions = true" @blur="hideSuggestionsDelayed" />

                        <div v-if="showSuggestions" class="absolute w-full bg-white border border-gray-200 rounded-lg mt-1 shadow-lg z-10">
                            <div v-if="loadingSearchClient" class="px-4 py-2 text-sm text-gray-500">
                                <i class="fas fa-spinner fa-spin"></i> Recherche en cours...
                            </div>

                            <div v-if="!loadingSearchClient">
                                <ul v-if="filteredClients.length" class="max-h-52 overflow-y-auto">
                                    <li v-for="client in filteredClients" :key="client.id" @mousedown.prevent="selectClient(client)" class="px-4 py-2 hover:bg-red-100 cursor-pointer text-sm">
                                        <div>
                                            <span class="font-medium">{{ client.prenom }} {{ client.nom }}</span>
                                            <span v-if="client.ville" class="text-gray-500 text-xs"> - {{ client.code_postal }} {{ client.ville }}</span>
                                        </div>
                                        <div>
                                            <span v-if="client.email" class="text-gray-500 text-xs">{{ client.email }}</span>
                                            <span v-if="client.telephone" class="text-gray-500 text-xs"> - {{ client.telephone }}</span>
                                        </div>
                                    </li>
                                </ul>

                                <div :class="filteredClients.length ? 'border-t' : ''">
                                    <button @click="openCreateClientModal" class="px-4 py-4 text-sm text-blue-500 hover:bg-blue-50 w-full text-left flex items-center gap-2">
                                        <i class="fas fa-plus"></i>
                                        Nouveau client
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button @click="openCreateClientModal" class="bg-slate-200 hover:bg-slate-300 px-3 py-3 rounded-lg flex items-center gap-2 text-xs">
                        <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>

            <!-- ADRESSE -->
            <div v-if="dataModel.client_id">
                <label class="text-sm font-bold text-gray-900">Adresse</label>

                <template v-if="loadingAdresses">
                    <div class="py-2 text-sm text-gray-500">
                        <i class="fas fa-spinner fa-spin"></i> Chargement des adresses...
                    </div>
                </template>

                <template v-if="!loadingAdresses">
                    <template v-if="adresses.length">
                        <div class="flex gap-2 mt-1">
                            <div class="relative flex-1">
                                <i class="fas fa-location-dot absolute left-3 top-3 text-gray-400"></i>

                                <select v-model="dataModel.adresse_id" class="pl-9 w-full rounded-lg border border-gray-300 focus:outline-none text-sm py-2">
                                    <option :value="null">Sélectionner une adresse</option>
                                    <option v-for="adresse in adresses" :key="adresse.id" :value="adresse.id">
                                        {{ formatAdresse(adresse) }}
                                    </option>
                                </select>
                            </div>

                            <button @click="openCreateAdresseModal" class="bg-slate-200 hover:bg-slate-300 px-3 py-3 rounded-lg flex items-center gap-2 text-xs">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>
                    </template>

                    <template v-else>
                        <div class="bg-slate-100 p-4 border rounded mt-1">
                            <p class="text-sm text-slate-600">
                                Aucune adresse trouvée pour ce client.
                            </p>

                            <div class="flex justify-center mt-4">
                                <button @click="openCreateAdresseModal" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                                    <i class="fas fa-plus"></i>
                                    Ajouter une adresse
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>

        <!-- MODALE AJOUT CLIENT -->
        <modal name="modal-add-client-simple" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Fiche client</h2>
                    <button @click="$modal.hide('modal-add-client-simple')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <client-form v-model="newClient" />

                <div class="flex justify-center mt-6">
                    <button :disabled="loadingCreateClient" @click="saveClient" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <template v-if="loadingCreateClient">
                            <i class="fas fa-spinner fa-spin"></i>
                        </template>
                        <template v-else>
                            <i class="fas fa-check"></i>
                            Enregistrer
                        </template>
                    </button>
                </div>
            </div>
        </modal>

        <!-- MODALE AJOUT ADRESSE -->
        <modal name="modal-add-adresse-simple" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-10 overflow-y-auto max-h-[100vh]" style="z-index: 999 !important;">
                <div class="flex items-center justify-between mb-4 pb-4 border-b text-2xl">
                    <h2 class="font-bold">Adresse</h2>
                    <button @click="$modal.hide('modal-add-adresse-simple')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <adresse-form v-model="newAdresse" />

                <div class="flex justify-center mt-6">
                    <button :disabled="loadingCreateAdresse" @click="saveAdresse" class="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg shadow transition flex items-center gap-2">
                        <template v-if="loadingCreateAdresse">
                            <i class="fas fa-spinner fa-spin"></i>
                        </template>
                        <template v-else>
                            <i class="fas fa-check"></i>
                            Enregistrer
                        </template>
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import ClientForm from '../../Client/Components/ClientForm.vue';
import AdresseForm from '../../Client/Components/AdresseForm.vue';

export default {
    name: 'ClientAdresseSelector',
    components: { ClientForm, AdresseForm },
    props: {
        value: {
            type: Object,
            default: () => ({
                client_id: null,
                adresse_id: null,
            }),
        },
    },
    data() {
        return {
            dataModel: {
                client_id: null,
                adresse_id: null,
                ...this.value,
            },

            clients: [],
            adresses: [],
            selectedClientData: null,

            clientSearch: '',
            showSuggestions: false,
            searchTimeout: null,

            newClient: {},
            newAdresse: {},

            loadingSearchClient: false,
            loadingCreateClient: false,
            loadingCreateAdresse: false,
            loadingAdresses: false,
        };
    },
    computed: {
        filteredClients() {
            if (!this.clientSearch || this.clientSearch.length < 2) {
                return [];
            }

            return this.clients;
        },
    },
    watch: {
        value: {
            handler(newValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.dataModel)) {
                    this.dataModel = {
                        client_id: null,
                        adresse_id: null,
                        ...newValue,
                    };
                }
            },
            deep: true,
        },
        dataModel: {
            handler(newValue) {
                this.$emit('input', { ...newValue });
            },
            deep: true,
        },
        clientSearch() {
            this.searchClients();
        },
    },
    methods: {
        async searchClients() {
            this.loadingSearchClient = true;
            clearTimeout(this.searchTimeout);

            this.searchTimeout = setTimeout(async () => {
                this.clients = [];

                if (!this.clientSearch || this.clientSearch.length < 2) {
                    this.loadingSearchClient = false;
                    return;
                }

                try {
                    const response = await this.$request.get('/clients', {
                        params: {
                            search: this.clientSearch,
                            with_adresses: 1,
                            type: 'proprietaire'
                        },
                    });

                    this.clients = response.data || response || [];
                } catch (error) {
                    console.error('Erreur recherche client', error);
                    this.clients = [];
                } finally {
                    this.loadingSearchClient = false;
                }
            }, 400);
        },

        async selectClient(client) {
            this.selectedClientData = client;
            this.dataModel.client_id = client.id;
            this.dataModel.adresse_id = null;
            this.clientSearch = `${client.prenom || ''} ${client.nom || ''}`.trim();
            this.showSuggestions = false;

            if (client.adresses && client.adresses.length) {
                this.adresses = client.adresses;
                this.dataModel.adresse_id = client.adresses[0].id;
            } else {
                this.adresses = [];
                await this.loadAdresses(client.id);
            }
        },

        async loadAdresses(clientId) {
            this.loadingAdresses = true;

            try {
                const response = await this.$request.get(`/clients/${clientId}/adresses`);
                this.adresses = response.data || response || [];

                if (this.adresses.length === 1) {
                    this.dataModel.adresse_id = this.adresses[0].id;
                }
            } catch (error) {
                console.error('Erreur chargement adresses', error);
                this.adresses = [];
            } finally {
                this.loadingAdresses = false;
            }
        },

        openCreateClientModal() {
            this.newClient = {
                nom: this.clientSearch || '',
            };
            this.$modal.show('modal-add-client-simple');
        },

        openCreateAdresseModal() {
            this.newAdresse = {
                nom_contact: this.selectedClientData ? `${this.selectedClientData.prenom || ''} ${this.selectedClientData.nom || ''}`.trim() : '',
                telephone: this.selectedClientData?.telephone || '',
            };

            this.$modal.show('modal-add-adresse-simple');
        },

        async saveClient() {
            const type  = this.newClient?.proprietaire?.type_client || 'particulier'
            const rules = type === 'professionnel'
                ? [
                    'proprietaire-societe:required|min=2',
                    'proprietaire-siret:required|siret',
                    'proprietaire-email:required|email',
                    'proprietaire-telephone:required|tel',
                ]
                : [
                    'proprietaire-nom:required|min=2',
                    'proprietaire-email:required|email',
                    'proprietaire-telephone:required|tel',
                ]

            const validation = this.$inpError(rules)
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            try {
                this.loadingCreateClient = true

                const response = await this.$request.post('/clients', this.newClient?.proprietaire || this.newClient)
                const client = response.client || response

                this.$modal.hide('modal-add-client-simple')
                this.newClient = {}

                client.adresses = client.adresses || []

                await this.selectClient(client)
            } catch (error) {
                console.error(error)
                this.$toast.error('Erreur lors de la création du client')
            } finally {
                this.loadingCreateClient = false
            }
        },

        async saveAdresse() {
            const { regie, locataire, ...adressePayload } = this.newAdresse

            const hasRegie     = !!(regie && regie.nom)
            const hasLocataire = !!(locataire && (locataire.nom || locataire.prenom || locataire.email || locataire.telephone))

            const proprietaireType = this.selectedClientData?.type_client || 'particulier'
            const regieType        = regie?.type_client                   || 'particulier'
            const locataireType    = locataire?.type_client               || 'particulier'

            const rules = []

            // Propriétaire
            if (hasRegie) {
                rules.push('proprietaire-nom:required|min=2')
            } else if (proprietaireType === 'professionnel') {
                rules.push(
                    'proprietaire-nom:required|min=2',
                    'proprietaire-siret:required|siret',
                )
            } else {
                rules.push(
                    'proprietaire-nom:required|min=2',
                    'proprietaire-email:required|email',
                    'proprietaire-telephone:required|tel',
                )
            }

            // Régie
            if (hasRegie) {
                if (regieType === 'professionnel') {
                    rules.push(
                        'regie-nom:required|min=2',
                        'regie-siret:required|siret',
                        'regie-email:required|email',
                        'regie-telephone:required|tel',
                    )
                } else {
                    rules.push(
                        'regie-nom:required|min=2',
                        'regie-email:required|email',
                        'regie-telephone:required|tel',
                    )
                }
            }

            // Locataire particulier
            if (hasLocataire && locataireType === 'particulier') {
                rules.push(
                    'locataire-nom:required|min=2',
                    'locataire-email:required|email',
                    'locataire-telephone:required|tel',
                )
            }

            // Locataire pro
            if (hasLocataire && locataireType === 'professionnel') {
                rules.push(
                    'locataire-societe:required|min=2',
                    'locataire-siret:required|siret',
                    'locataire-email:required|email',
                    'locataire-telephone:required|tel',
                )
            }

            const validation = this.$inpError(rules)
            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            if (locataire && !hasLocataire) {
                this.$toast.error('Veuillez remplir au moins un champ pour le locataire')
                return
            }

            try {
                this.loadingCreateAdresse = true

                const payload = {
                    ...adressePayload,
                    client_id: this.dataModel.client_id,
                }

                const response = await this.$request.post(`/clients/${this.dataModel.client_id}/adresses`, payload)
                const adresse = response.data || response

                this.adresses.push(adresse)
                this.dataModel.adresse_id = adresse.id

                this.$modal.hide('modal-add-adresse-simple')
                this.newAdresse = {}
            } catch (error) {
                console.error(error)
                this.$toast.error("Erreur lors de l'ajout de l'adresse")
            } finally {
                this.loadingCreateAdresse = false
            }
        },

        hideSuggestionsDelayed() {
            setTimeout(() => {
                this.showSuggestions = false;
            }, 200);
        },

        formatAdresse(adresse) {
            return [adresse.adresse1, adresse.code_postal, adresse.ville].filter(Boolean).join(' ');
        },
    },
};
</script>

<style scoped>
ul::-webkit-scrollbar {
    width: 6px;
}

ul::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 3px;
}
</style>